<template>
  <div>
    <div class="breacrumb-section" v-if="detalhe!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $t('breadcrumb.exchange') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section>
    <div class="container">
        <div class="titulo-cambio">
            <h2>{{ $t('exchange.title') }}</h2><br><br>
            <iframe src="https://br.widgets.investing.com/live-currency-cross-rates?theme=darkTheme&cols=ask,changePerc,time&pairs=1617,1121152" width="100%" height="220px" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0"></iframe><div class="poweredBy" style="font-family: Arial, Helvetica, sans-serif;">Desenvolvido por <a href="https://br.investing.com?utm_source=WMT&amp;utm_medium=referral&amp;utm_campaign=LIVE_CURRENCY_X_RATES&amp;utm_content=Footer%20Link" target="_blank" rel="nofollow">Investing.com</a></div>
        </div>
    </div>
    </section>
  </div>
</template>

<script>
//import moment from 'moment'
import axios from 'axios';
import { useHead } from '@vueuse/head';

export default {
  name: 'SobreView',
  components: {
  },
  data: () => ({
  }),
  methods: {
    carregaMetas() {
			useHead({
				title: 'Cambio - Sub4 Turismo'
			})
		},
  },
  created() {
    this.carregaMetas();
  },
}
</script>

<style>
</style>
